import { BankAccountType } from 'src/utils/constants/clients';
import { isBankCodeValid } from 'src/utils/payments';
import * as Yup from 'yup';

const validationSchema = bankList =>
  Yup.object().shape({
    bankName: Yup.string().required('SCHEMA_ERRORS.REQUIRED_FIELD'),
    bankAccountType: Yup.string().required('SCHEMA_ERRORS.REQUIRED_FIELD'),
    bankAccountNumber: Yup.string()
      .test(
        'valid-bank-code',
        'SCHEMA_ERRORS.INVALID_BANK_CODE',
        function validBankCodeTest(value) {
          const { bankName, bankAccountType } = this.parent;
          if (bankAccountType !== BankAccountType.CLABE) {
            return true;
          }
          return isBankCodeValid(value, bankName, bankList);
        }
      )
      .required('SCHEMA_ERRORS.REQUIRED_FIELD')
      .when('bankAccountType', {
        is: BankAccountType.SANTANDER_CHECKS,
        then: schema =>
          schema
            .length(11, 'SCHEMA_ERRORS.INVALID_FORMAT_SANTANDER_CHECKS')
            .required('SCHEMA_ERRORS.REQUIRED_FIELD')
      })
      .when('bankAccountType', {
        is: BankAccountType.DEBIT_CARD,
        then: schema =>
          schema
            .length(16, 'SCHEMA_ERRORS.INVALID_FORMAT_DEBIT_CARD')
            .required('SCHEMA_ERRORS.REQUIRED_FIELD')
      })
      .when('bankAccountType', {
        is: BankAccountType.CLABE,
        then: schema =>
          schema
            .length(18, 'SCHEMA_ERRORS.INVALID_FORMAT_CLABE')
            .required('SCHEMA_ERRORS.REQUIRED_FIELD')
      })
  });

export default validationSchema;
